import { logInfo } from 'utils/logging';

type LoginRequestResponse = {
  success: boolean;
  error: string | null;
  nextPath: string | null;
};

async function loginRequest(login: string, password: string) {
  const _req = {
    query: `
    mutation {
      signIn(
          input: {
            params: {
              login: "${login}",
              password: "${password}"
            }
          }
        ) {
        payload {
          success
        }
      }
    }
    `,
  };

  const _res: LoginRequestResponse = {
    success: false,
    error: null,
    nextPath: null,
  };

  try {
    const response = await fetch(`/teens/gateway`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(_req),
    });
    const result = await response.json();
    if (result?.data?.signIn?.payload?.success === true) {
      _res.success = true;
      _res.nextPath = result.data.signIn.payload.nextPath;
    } else if (Array.isArray(result?.errors)) {
      result.errors.forEach((error: any) => {
        // ошибка всего одна и ее записывают в поле password
        const passwordErrors = error?.extensions?.details?.password;
        passwordErrors.forEach((passwordError: any) => {
          if (passwordError?.code === 'wrong_login_or_password') {
            _res.error = 'Неверная пара логина и пароля';
          }
        });
      });
    } else {
      _res.error = 'Неизвестная ошибка';
    }
  } catch (error: any) {
    logInfo(error.toString(), true);
    _res.error = 'Неизвестная ошибка';
  }

  return _res;
}

export default loginRequest;
